// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1RaftStatusMember } from './V1RaftStatusMember';
import {
  V1RaftStatusMemberFromJSON,
  V1RaftStatusMemberFromJSONTyped,
  V1RaftStatusMemberToJSON,
  V1RaftStatusMemberToJSONTyped,
} from './V1RaftStatusMember';

/**
 *
 * @export
 * @interface V1RaftStatus
 */
export interface V1RaftStatus {
  /**
   *
   * @type {Array<V1RaftStatusMember>}
   * @memberof V1RaftStatus
   */
  raftMembers?: Array<V1RaftStatusMember>;
}

/**
 * Check if a given object implements the V1RaftStatus interface.
 */
export function instanceOfV1RaftStatus(value: object): value is V1RaftStatus {
  return true;
}

export function V1RaftStatusFromJSON(json: any): V1RaftStatus {
  return V1RaftStatusFromJSONTyped(json, false);
}

export function V1RaftStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1RaftStatus {
  if (json == null) {
    return json;
  }
  return {
    raftMembers:
      json['raftMembers'] == null
        ? undefined
        : (json['raftMembers'] as Array<any>).map(V1RaftStatusMemberFromJSON),
  };
}

export function V1RaftStatusToJSON(json: any): V1RaftStatus {
  return V1RaftStatusToJSONTyped(json, false);
}

export function V1RaftStatusToJSONTyped(
  value?: V1RaftStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    raftMembers:
      value['raftMembers'] == null
        ? undefined
        : (value['raftMembers'] as Array<any>).map(V1RaftStatusMemberToJSON),
  };
}
